/* unplugin-vue-components disabled */import { render } from "./clinicalGuideline.vue?vue&type=template&id=eaa476e0&scoped=true"
import script from "./clinicalGuideline.vue?vue&type=script&lang=js"
export * from "./clinicalGuideline.vue?vue&type=script&lang=js"

import "./clinicalGuideline.vue?vue&type=style&index=0&id=eaa476e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaa476e0"]])

export default __exports__